import { createFileRoute } from '@tanstack/react-router';

import { Workspace } from '@/features/settings';

export const Route = createFileRoute('/_auth/settings/workspace')({
  component: Workspace,
  notFoundComponent: () => {
    return <p>Workspace not found!</p>;
  },
});
